import meetingService from '@/services/api/plataformas/meeting';
import recordingService from '@/services/api/plataformas/recording';

export default {
  namespaced: true,
  modules: {
    meeting: meetingService,
    recording: recordingService,
  },
};
